module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("伟嘉视角")])]), _vm._v(" "), _c('div', {
    staticClass: "subbar-wrap",
    class: {
      noTop: _vm.isWechat
    }
  }, [_c('ul', {
    staticClass: "subbar-father"
  }, _vm._l((_vm.articleTypeArr), function(supType, index) {
    return _c('li', {
      key: supType.id,
      class: {
        active: _vm.selectSupTypeIndex === index
      },
      on: {
        "click": function($event) {
          _vm.changeArticleType(supType, index)
        }
      }
    }, [_vm._v(_vm._s(supType.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "subbar-son",
    class: {
      typeTop: _vm.isWechat
    }
  }, [_c('typebar', {
    attrs: {
      "type-list": _vm.getSubType,
      "select-type-index": _vm.selectSubTypeIndex,
      "color": '#9CA5AE',
      "activeColor": '#21507F',
      "bd-color": '#129FDD'
    },
    on: {
      "click-handler": _vm.clickSubType
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "pageContent",
    staticClass: "page-content",
    class: {
      contentTop: _vm.isWechat
    }
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-infinite": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "perspective"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.articleArr), function(article) {
    return _c('router-link', {
      key: article.id,
      staticClass: "list-item clearfix",
      attrs: {
        "tag": "li",
        "to": ("/perspective/article/" + (article.id))
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
      staticClass: "time text-right"
    }, [_vm._v(_vm._s(article.addDate))])])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eed11f02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/perspective.vue
// module id = 380
// module chunks = 1